import Vue from 'vue';
import store from './../../store';
import clientGroupTransformer from './../../transformers/clientGroup';

const success = ({ data }, resolve) => {
  const clientGroups = clientGroupTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllClientGroups', clientGroups);

  resolve(clientGroups);
};

const failed = (error, reject) => reject(error);


export default (search = null) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(search === null ? 'client_groups' : `/client_groups?search=${search}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client-group/all.js